module.exports = __webpack_public_path__ + "img/img_10_brand_retail@3x.8ecf4cc1.png";